var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHubspot = function SvgHubspot(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 43 43"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ebf1ff",
    d: "M0 0h42.163v42.163H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff7a59",
    d: "M4.941 2.635h32.28a2.306 2.306 0 0 1 2.307 2.306v32.28a2.306 2.306 0 0 1-2.306 2.306H4.94a2.305 2.305 0 0 1-2.306-2.305V4.94A2.306 2.306 0 0 1 4.94 2.634"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M27.595 16.284v-3.008a2.32 2.32 0 0 0 1.338-2.09v-.07a2.323 2.323 0 0 0-2.316-2.317h-.071a2.323 2.323 0 0 0-2.317 2.316v.07a2.32 2.32 0 0 0 1.323 2.085l.013.006v3.014a6.6 6.6 0 0 0-3.137 1.384l.013-.01-8.271-6.44a2.638 2.638 0 1 0-1.223 1.6l-.012.007 8.131 6.33a6.53 6.53 0 0 0-1.096 3.64 6.56 6.56 0 0 0 1.212 3.81l-.014-.02-2.475 2.475a2 2 0 0 0-.613-.1h-.002a2.149 2.149 0 1 0 2.148 2.148 2.1 2.1 0 0 0-.104-.629l.004.015 2.448-2.448a6.6 6.6 0 1 0 5.053-11.763l-.038-.006zm-1.018 9.907a3.388 3.388 0 1 1 3.395-3.387v.002a3.387 3.387 0 0 1-3.387 3.387z"
  })));
};
export default SvgHubspot;